import { IS_CLIENT } from '../constants';
const { nanoid } = require('nanoid');
if (IS_CLIENT && !window.crypto) {
    // @ts-ignore
    window.crypto = window.msCrypto;
}
/**
 * is a wrapper for nanoid to be able to polyfill crypto from IE
 * @returns {String} random string with help from nanoid
 */
const getRandomStr = () => {
    return nanoid();
};
export default getRandomStr;
//# sourceMappingURL=getRandomStr.js.map